import { useState } from "react";
import React from "react";
import SbuxTranslate from "../SbuxTranslate";
import { Tabs, Tab, Box, TabScrollButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./styles";
import useCss from "../../hooks/useCss";

interface SubTabItem {
  value: string;
  name: string;
  disabled?: boolean;
  [key: string]: unknown;
}

interface Props {
  tabList?: SubTabItem[];
  tabId?: string;
  handleTabChange?: (value: string) => void;
  width?: string | number;
  maxWidth?: string | number;
  disabled?: boolean;
  children?: React.ReactNode;
  handleTabClick?: (tab: SubTabItem) => void;
}

const SbuxSubTabs = ({
  tabList,
  tabId,
  handleTabChange,
  width,
  maxWidth,
  disabled = false,
  children,
  handleTabClick,
}: Props) => {
  const [activeTabId, setActiveTabId] = useState(tabId);
  const classes = useCss(styles);

  const tabScrollButton = styled(TabScrollButton)(({ theme }) => ({
    root: {
      width: "16px !important",
      backgroundColor: `${theme.palette.darkGray.main} !important`,
      color: theme.palette.white.main,
      fontSize: "20px",
      overflow: "hidden",
      transition: "width .1s",
      "&.Mui-disabled": {
        width: 0,
      },
    },
  }));

  const handleTabOnChange = (
    _event: React.SyntheticEvent,
    newValue: string,
  ) => {
    if (handleTabChange) {
      handleTabChange(newValue);
      setActiveTabId(newValue);
    }
  };

  if (activeTabId !== tabId) {
    setActiveTabId(tabId);
  }

  return (
    <Box>
      <Tabs
        sx={{
          "&.MuiTabs-root": {
            minHeight: "26px !important",
            fontWeight: 600,
            width: width ?? "100%", // prev: 32vw
            maxWidth: maxWidth ?? "100%",
          },
          opacity: disabled ? 0.65 : 1,
          pointerEvents: disabled ? "none" : "initial",
        }}
        variant="scrollable"
        allowScrollButtonsMobile
        scrollButtons="auto"
        ScrollButtonComponent={tabScrollButton}
        value={activeTabId}
        slotProps={{
          indicator: {
            style: {
              display: "none",
            },
          },
        }}
        onChange={handleTabOnChange}
      >
        {!children &&
          tabList &&
          tabList.length > 0 &&
          tabList.map((tab: SubTabItem, index: number) => {
            return (
              <Tab
                value={tab.value}
                label={<SbuxTranslate>{tab.name}</SbuxTranslate>}
                key={index}
                className={classes.rootTab}
                disabled={tab.disabled}
                onClick={() => {
                  handleTabClick && handleTabClick(tab);
                }}
              />
            );
          })}
        {children && children}
      </Tabs>
    </Box>
  );
};

export default SbuxSubTabs;
